angular.module('menu').component('helpMenu', {
    templateUrl: 'js/modules/menu/components/help-menu/template.html',
    controller: 'HelpMenuController',
});
